import { EuiSkeletonText } from "@inscopix/ideas-eui";

/** Component rendered when a file preview is being retrieved */
export const FilePreviewLoading = () => {
  return <EuiSkeletonText lines={10} />;
};
